import {
	Box,
	ButtonLayout,
	ButtonPrimary,
	Carousel,
	Grid,
	PageBullets,
	Stack,
	Touchable,
	useScreenSize,
} from "@telefonica/mistica";
import React from "react";
import { HeroDataInfo } from "../HeroDataInfo";
import { strings } from "../../localization";
import { slides } from "./data";
import { CardWithBorder } from "../CardWithBorder";
import { useAnalytics } from "../../hooks";

interface IProps {
	buttonTitle: string;
	onContinue(): void;
}

export const AnticipationAdvantages: React.FC<IProps> = (props) => {
	const { buttonTitle, onContinue } = props;
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const { title, description, texts } = strings.components.AnticipationAdvantages;
	const numPages = texts.length;
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent } = useAnalytics();

	const handlePageChange = (newPageInfo: { pageIndex: number }): void => {
		setCurrentIndex(newPageInfo.pageIndex);
	};

	const onTriggerTagging = (description: string) => {
		addAnalyticEvent({
			component: "body",
			action: "click:slider",
			step: "home:sliders:vantagens-fgts",
			description,
		}, {
			applySanitize: true,
		});
	};

	return (
		<Stack space={isDesktopOrBigger ? 40 : 32}>
			<Box paddingX={isDesktopOrBigger ? 0 : 24}>
				<HeroDataInfo title={title} description={description} />
			</Box>
			<Box paddingLeft={isDesktopOrBigger ? 0 : 24} paddingRight={24}>
				{isDesktopOrBigger ? (
					<Grid columns={3} rows={2} gap={24}>
						{slides.map((slide, index) => (
							<CardWithBorder
								key={index + 1}
								icon={<Box>{slide.icon}</Box>}
								title={slide.title}
								description={slide.description}
							/>
						))}
					</Grid>
				) : (
					<Stack space={8}>
						<Carousel
							onPageChange={handlePageChange}
							itemsPerPage={1}
							items={slides.map((slide, index) => (
								<Touchable onPress={() => onTriggerTagging(slide.title)} style={{ cursor: "default" }}>
									<CardWithBorder
										key={index + 1}
										icon={<Box>{slide.icon}</Box>}
										title={slide.title}
										description={slide.description}
									/>
								</Touchable>
							))}
						/>
					</Stack>
				)}
			</Box>
			<Box paddingX={isDesktopOrBigger ? 0 : 24}>
				<ButtonLayout align="left">
					<ButtonPrimary
						onPress={onContinue}
						style={{
							borderRadius: "999px",
						}}
					>
						{buttonTitle}
					</ButtonPrimary>
				</ButtonLayout>
			</Box>
		</Stack>
	);
};
